import { render, staticRenderFns } from "./AddLabel.vue?vue&type=template&id=43c04ae1&scoped=true"
import script from "./AddLabel.vue?vue&type=script&lang=ts"
export * from "./AddLabel.vue?vue&type=script&lang=ts"
import style0 from "./AddLabel.vue?vue&type=style&index=0&id=43c04ae1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c04ae1",
  null
  
)

export default component.exports